export enum UploaderType {
	Normal,
	External,
	Embedded,
}
